// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-footer{
    background: var(--color-white);
    left: 0px;
    right: 0;
    bottom: 0;
    position: fixed;
    text-align: center;
    padding: 4px;
    font-size: 10px;
    border-top: 1px solid #e4e4e4;
    z-index: 3;
}
.wrapper.toggled .page-footer{
	left: 0;
}

@media (max-width: 768px) {
    .page-footer {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/containers/footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,QAAQ;IACR,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,UAAU;AACd;AACA;CACC,OAAO;AACR;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".page-footer{\n    background: var(--color-white);\n    left: 0px;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n    text-align: center;\n    padding: 4px;\n    font-size: 10px;\n    border-top: 1px solid #e4e4e4;\n    z-index: 3;\n}\n.wrapper.toggled .page-footer{\n\tleft: 0;\n}\n\n@media (max-width: 768px) {\n    .page-footer {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
